import React from 'react';
import PropTypes from 'prop-types';
import {applicationName} from './application-constants.js';

export const styleFrameworkContext = React.createContext({
  application: applicationName.STORES,
  brands: {
    activeBrand: 1,
    isAnyWayfair: true,
    WAYFAIR: 1,
    PARTNERHOME: 0,
    ALLMODERN: 0,
    BIRCH: 0,
    BIRCHLANE: 0,
    JOSS: 0,
    JOSSANDMAIN: 0,
    PERIGOLD: 0,
    WAYFAIR_CA: 0,
    WAYFAIR_DE: 0,
    WAYFAIR_UK: 0,
  },
});

export function Provider({children, styleFramework}) {
  if (typeof styleFramework === 'undefined') {
    throw new Error(
      'No styleFramework value provided. You must provide a prop with the application name and brand configuration.'
    );
  }
  return (
    <styleFrameworkContext.Provider value={styleFramework}>
      {children}
    </styleFrameworkContext.Provider>
  );
}
Provider.propTypes = {
  children: PropTypes.node.isRequired,
  styleFramework: PropTypes.shape({
    application: PropTypes.oneOf(['intranet', 'extranet', 'stores']),
    brands: PropTypes.shape({
      activeBrand: PropTypes.number,
      ALLMODERN: PropTypes.number,
      BIRCH: PropTypes.number,
      BIRCHLANE: PropTypes.number,
      JOSS: PropTypes.number,
      JOSSANDMAIN: PropTypes.number,
      PERIGOLD: PropTypes.number,
      PARTNERHOME: PropTypes.number,
      WAYFAIR: PropTypes.number,
      WAYFAIR_CA: PropTypes.number,
      WAYFAIR_DE: PropTypes.number,
      WAYFAIR_UK: PropTypes.number,
    }).isRequired,
  }),
};

export function Consumer({children}) {
  return (
    <styleFrameworkContext.Consumer>
      {(styleFramework) => {
        if (typeof styleFramework === 'undefined') {
          throw new Error(
            'No styleFramework found in context. Ensure the root of the application is wrapped in a Provider with a valid value.'
          );
        }
        return children(styleFramework);
      }}
    </styleFrameworkContext.Consumer>
  );
}
Consumer.propTypes = {
  children: PropTypes.func.isRequired,
};
